import {
	Card,
	CardBody,
	Container,
	Row,
	Col,
	Button,
	Breadcrumb,
	BreadcrumbItem,
	CardHeader,
} from "reactstrap"
// core components
import { Component } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { user } from "../../../redux/actions"

import { getMaritalStatus } from "../../../helper"
import moment from "moment"

class DetailUser extends Component {
	getUser() {
		this.props.getUser(this.props.match.params.userId)
	}
	componentDidMount() {
		this.getUser()
	}

	render() {
		return (
			<>
				{/* Page content */}
				<Container fluid className='mb-5'>
					<div>
						<Breadcrumb>
							<BreadcrumbItem>
								<Link to='/admin/user'>User</Link>
							</BreadcrumbItem>

							<BreadcrumbItem active>Detail User</BreadcrumbItem>
						</Breadcrumb>
					</div>
					{/* Table */}
					<Row>
						<Col xl={7}>
							<Card>
								<CardHeader>
									<h1>Detail User</h1>
								</CardHeader>
								<CardBody>
									<Container>
										<table>
											<tr>
												<td
													style={{
														minWidth: "200px",
													}}
												>
													Nama
												</td>
												<th>{this.props.user.detail.name}</th>
											</tr>

											<tr>
												<td>Email</td>
												<th>{this.props.user.detail.email}</th>
											</tr>

											<tr>
												<td>No. Whatsapp</td>
												<th>{this.props.user.detail.phone}</th>
											</tr>

											<tr>
												<td>Tanggal Lahir</td>
												<th>
													{moment(
														this.props.user.detail.UserDetail.birthdate,
														"YYYY-MM-DD"
													)
														.locale("id")
														.format("DD MMM YYYY")}
												</th>
											</tr>

											<tr>
												<td>Alamat Lengkap</td>
												<th>{this.props.user.detail.UserDetail.address}</th>
											</tr>

											<tr>
												<td>Profesi</td>
												<th>{this.props.user.detail.UserDetail.profession}</th>
											</tr>

											<tr>
												<td>Status Perkawinan</td>
												<th>
													{getMaritalStatus(
														this.props.user.detail.UserDetail.marital_status
													)}
												</th>
											</tr>
										</table>

										<div className='d-flex justify-content-end'>
											<Button
												color='primary'
												onClick={() => {
													this.props.history.push("/admin/user")
												}}
											>
												Kembali
											</Button>
										</div>
									</Container>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return { user: state.user }
}

const mapDispatchToProps = {
	getUser: user.getUser,
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailUser)
